import React, { useState, useRef, useEffect } from "react";

export const ConfirmButton = ({ onConfirm, message = "Emin misiniz?", confirmText = "Evet", cancelText = "İptal", children, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [style, setStyle] = useState({});
  const btnRef = useRef(null);
  const popRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popRef.current && !popRef.current.contains(e.target) && btnRef.current && !btnRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const popupHeight = 120;
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceAbove >= popupHeight;
    setStyle({
      left: rect.right - 180,
      top: above ? rect.top - 8 : rect.bottom + 8,
      transform: above ? "translateY(-100%)" : "translateY(0)",
    });
    setOpen(true);
  };

  return (
    <>
      <div ref={btnRef} onClick={handleClick} className={`inline-flex ${className}`}>
        {children}
      </div>
      {open && (
        <div ref={popRef} style={style} className="fixed z-[99999] min-w-[180px]">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700 p-3">
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-3 whitespace-nowrap text-center">{message}</p>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => { setOpen(false); onConfirm(); }}
                className="flex-1 px-3 py-1.5 text-xs font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
              >
                {confirmText}
              </button>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="flex-1 px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
              >
                {cancelText}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
